import React, { useState, useEffect } from "react";
import { userActions } from "../../_actions/index.js";
import { useDispatch, useSelector } from "react-redux";
///module Imports
import { useTranslation } from "react-i18next";

import AOS from "aos";
import "aos/dist/aos.css";
import Tippy from "@tippyjs/react";
import "tippy.js/dist/tippy.css";

import { Router, Routes, Route, Link } from "react-router-dom";

//navbar import
import Navbar from "./navbar/Navbar.js";

//404 not found page
import Error404 from "./Error404.js";

//profileManagemer
import Profile from "./profileManager/Profile.js";

//student components
import StudentDashboard from "./Students/dashboard/Dashboard.js";
import StudentAnnouncement from "./Students/announcement/Announcement.js";
import StudentAchievements from "./Students/achievements/Achievements.js";
// import StudentResult from "./Students/results/Results.js";
import StudentWebinar from "./Students/webinar/Webinar.js";
import StudentCourses from "./Students/courses/Courses.js";
import StudentClasses from "./Students/courses/StudentClasses.js";
import InstructorClasses from "./Teachers/InstructorClasses.js";
import { Loading } from "../Other/Loading.js";
import StudentNotes from "./Students/notes/Notes.js";
import StudentForum from "./Students/forum/Forums.js";
import CourseEdit from "./Teachers/CreateCourse/CourseQuestion/CourseBuilderComponents/CourseEdit/CourseEdit.js";
import CurrentSubscription from "../Enterprise/CurrentSubscription";
import Wishlist from "./Students/wishlist/wishlist.js";
import CreateBundle from "./Teachers/CreateCourse/CreateBundle.js";
import CreateOfferPage from "./Teachers/CreateOfferPage.js";
import CreateCouponPage from "./Teachers/CreateCouponPage.js";
//teachers components
import CreateCourse from "./Teachers/CreateCourse/CreateCourse.js";
import CourseList from "./Teachers/CourseList.js";
import CreateCourseSection from "./Teachers/CreateCourse/CreateCourseSection.js";

import CourseBuilder from "./Teachers/CreateCourse/CourseQuestion/CourseBuilder.js";
import SessionExpire from "../Other/SessionExpire/SessionExpire.js";
import ViewAward from "./Teachers/Awards/ViewAward.js";
import MemberList from "./Teachers/MemberList/MemberList.js";
import StudentsList from "./Teachers/StudentList/StudentList.js";
import WebinarEvents from "./Students/webinar/WebinarEvents.js";

import BundleList from "./Teachers/BundleList.js";
import StudentData from "./Teachers/MemberList/StudentData.js";
import CourseReport from "./Teachers/MemberList/CourseReport.js";
import MonthReport from "./Teachers/MemberList/MonthReport.js";
import TeacherReport from "./Teachers/MemberList/TeacherReport.js";
import QuizResult from "./Students/dashboard/QuizResult.js";
import PaymentReport from "./Teachers/MemberList/PaymentReport.js";
import AdminQuizResults from "./Teachers/MemberList/AdminQuizResults.js";
import Announcement from "./Students/announcement/Announcement.js";
import LanguisityReport from "./Teachers/MemberList/LanguisityReport.js";
import GroupFeedbacksReport from "./Teachers/MemberList/GroupFeedbacksReport.js";
import { useLocation, useNavigate } from "react-router";
import { addCartItem } from "../../_services/cart.service.js";
import {
  addToCartOffLine,
  resetCart,
  storeUserRoute,
} from "../../_actions/cart.actions.js";
import AllCategories from "./Teachers/CreateCourse/AllCategories.js";
import CourseProject from "./Teachers/CreateCourse/CourseProject.js";
import PageData from "./pages/index.js";
import Preview from "./preview/preview.js";
import CoursePurchasedList from "./Students/dashboard/CoursePurchasedList.js";
import InstructorStudentList from "./Teachers/StudentList.js";
import smiklogo from "../../assets/images/logo.png";

import { FaHome, FaChalkboardTeacher, FaUsers, FaChartBar, FaAward, FaBookOpen, FaShoppingCart, FaHeart, FaVideo, FaStickyNote, FaComments, FaTrophy, FaBullhorn, FaListAlt, FaUserGraduate, FaBook, FaAddressBook, FaCalendarAlt, FaPlus, FaBriefcase } from "react-icons/fa";
import { MdVideoLibrary, MdWeb, MdCategory } from "react-icons/md";
import { AiOutlineProject, AiOutlineAppstore } from "react-icons/ai";
import { BiBookBookmark } from "react-icons/bi";
import InstructorAttendance from "./Students/dashboard/InstructorAttendance.js";
import Quizs from "./Students/dashboard/Quiz.js";
import QuizExam from "./Students/dashboard/QuizExam.js";
import BatchGroup from "./Students/Group/BatchGroup.js";
import StudentGroupBatchList from "./Students/Group/student/StudentGroupBatchList.js";
import StudentAttendanceList from "./Students/dashboard/StudentAttendanceList.js";
import StudentCourseAttendance from "./Students/dashboard/StudentCourseAttendance.js";
import StudentAttendance from "./Students/dashboard/StudentAttendance.js";
import InstructorBatchSchedules from "./Students/Group/InstructorBatchSchedules.js";
import InstructorCreateBatch from "./Students/Group/InstructorCreateBatch.js";
import VerifyAttendance from "./Teachers/MemberList/VerifyAttendance.js";
import Testimonials from "./Teachers/Testimonial/Testimonials.js";
import ReviewApprove from "./Students/ReviewApprove.js";
import { FaPerson } from "react-icons/fa6";
import InstructorRequests from "./Teachers/Requests/InstructorRequests.js";
import RequestCorporateTraining from "./Teachers/Requests/RequestCorporateTraining.js";
import Requestgrievanceredressal from "./Teachers/Requests/requestgrievanceredressal.js";
import RequestContact from "./Teachers/Requests/RequestContact.js";
import RequestPartner from "./Teachers/Requests/RequestPartner.js";
import RequestCourse from "./Teachers/Requests/RequestCourse.js";
import Contactusrequests from "./Teachers/Requests/Contactusrequests.js";
import PricingPlans from "./Teachers/Pricing/Pricing.js";
import ContactSales from "./Teachers/Requests/ContactSales.js";
import Aboutus from "./Teachers/Public/AboutUs.js";
import AboutInfo from "./Teachers/Public/AboutInfo.js";
import JsonPageEditor from "./Teachers/Public/JsonsPageData.js";
import SeoPage from "./Teachers/Public/SeoPage.js";
import HomePreview from "./homebanner/homepreview.js";
import ExamAndQuiz from "./promptEngineer/Quizes/ExamAndQuiz.js";
import Webinar from "./promptEngineer/Webinar/Webinar.js";
import CalendarPage from "./calendar/CalendarPage.js";
import RemindersPage from "./reminders/RemindersPage.js";
import SettingsPage from "./settings/SettingsPage.js";
// import JobsManagement from "../Jobs/JobsManagement.js";


export default function Main(props) {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { user } = useSelector((state) => state.users);
  const { geoLocation } = useSelector((state) => state.authentication);
  const { cartItems, CartItemsList, comeFromRoute } = useSelector(
    (state) => state.cart
  );
  const location = useLocation();
  // const { state } = location;

  useEffect(() => {
    // if (state?.comeFrom === "OpenPaymentOption") {
    if (user) {
      if (geoLocation) {
        if (comeFromRoute === "CART" && user.role === 2) {
          // setTimeout(() => {
          dispatch(
            addToCartOffLine(
              {
                bundles: CartItemsList.filter((x) =>
                  x.hasOwnProperty("bundleOneLiner")
                ).map((data) => data.ID),
                courses: CartItemsList.filter(
                  (x) => !x.hasOwnProperty("bundleOneLiner")
                ).map((data) => data.ID),
              },
              null,
              geoLocation,
              false
            )
          );

          navigate("/cart");
          // console.log("🚀 ~ file: Main.js:86 ~ useEffect ~ CartItemsList:", CartItemsList)
          // }, 1000);
          // loaderFunc()
          // const bundles = CartItemsList.filter(x => x.hasOwnProperty('bundleOneLiner')).map((data) => data.ID);
          // const courses = CartItemsList.filter(x => !x.hasOwnProperty('bundleOneLiner')).map((data) => data.ID);
          // addCartItem({
          //   bundles: CartItemsList.filter(x => x.hasOwnProperty('bundleOneLiner')).map((data) => data.ID),
          //   courses: CartItemsList.filter(x => !x.hasOwnProperty('bundleOneLiner')).map((data) => data.ID)
          // })
          // dispatch(addToCartOffLine({
          //   bundles: CartItemsList.filter(x => x.hasOwnProperty('bundleOneLiner')).map((data) => data.ID),
          //   courses: CartItemsList.filter(x => !x.hasOwnProperty('bundleOneLiner')).map((data) => data.ID)
          // }))
          // dispatch(resetCart());
        } else {
          dispatch(resetCart());
          dispatch(storeUserRoute(null));
        }
      }
    }
  }, [comeFromRoute, user, geoLocation]);

  const loaderFunc = () => {
    return <Loading />;
  };

  const [value, setValue] = useState(
    window.localStorage.getItem("tabsvalue")
      ? parseInt(window.localStorage.getItem("tabsvalue"))
      : 0
  );
  const { t } = useTranslation();
  const [showIconsOnly, setShowIconsOnly] = useState(false);
  const [dropdownToggle, setDropdownToggle] = useState(null);
  useEffect(() => {
    function tr() {
      AOS.init({ duration: 750, easing: "ease-in-quad" });
    }
    tr();
  });

  useEffect(() => {
    dispatch(userActions.getUserInfo());
  }, []);

  if (!user) {
    return <Loading />;
  }


  // Importing relevant icons from react-icons


  const adminMenu = [
    // Dashboard
    {
      label: t("sideMenu.dashboard"),
      icon: <FaHome />, // Home icon
      url: "/dashboard/",
      component: StudentDashboard,
    },
    {
      label: "Categories",
      icon: <MdCategory />,
      url: "/dashboard/category/list",
      component: AllCategories,
    },
    {
      label: "Manage Offers",
      icon: <FaAward />,
      url: "/dashboard/admin/offers",
      component: CreateOfferPage,
    },
    {
      label: "Manage Coupons",
      icon: <FaAward />,
      url: "/dashboard/admin/coupons",
      component: CreateCouponPage,
    },
    {
      label: "Prompt Engineering",
      icon: <FaAddressBook />,
      innerComponents: [
        {
          label: t("Exams & Quizzes "),
          icon: <FaAddressBook />,
          url: "/dashboard/prompt/quiz",
          component: ExamAndQuiz,
        },
        {
          label: t("sideMenu.webinars"),
          icon: <FaVideo />,
          url: "/dashboard/prompt/webinar",
          component: Webinar,
        },
      ],
    },
    {
      label: "Group",
      icon: <FaUsers />,
      url: "/dashboard/group",
      component: BatchGroup,
    },
    // Courses Section
    {
      label: "Courses",
      icon: <MdVideoLibrary />, // Video library icon
      innerComponents: [
        {
          label: t("Course List"),
          icon: <MdVideoLibrary />, // Video library icon
          url: "/dashboard/course/list",
          component: CourseList,
        },
        {
          label: "Exams & Quiz",
          icon: <FaAward />, // Award icon for quizzes
          url: "/dashboard/student/quizs",
          component: Quizs,
        },
        {
          label: t("sideMenu.webinars"),
          icon: <FaVideo />,
          url: "/dashboard/webinars/list",
          component: WebinarEvents,
        },
        {
          label: "Manage Classes",
          icon: <FaCalendarAlt />,
          url: "/dashboard/admin/classes",
          component: InstructorClasses,
        },
        // {
        //   label: t("Create a Bundle"),
        //   icon: <AiOutlineAppstore />, 
        //   url: "/dashboard/CreateBundle",
        //   component: CreateBundle,
        // },

        // {
        //   label: t("All Bundle"),
        //   icon: <AiOutlineAppstore />,
        //   url: "/dashboard/allbundle",
        //   component: BundleList,
        // },
      ],
    },



    {
      label: "Instructors",
      icon: <FaChalkboardTeacher />,
      innerComponents: [
        {
          label: t("Listings"),
          icon: <FaChalkboardTeacher />,
          url: "/dashboard/instructor/list",
          component: MemberList,
        },
        {
          label: t("Attendance"),
          icon: <FaChalkboardTeacher />,
          url: "/dashboard/instructor/attendance",
          component: InstructorAttendance,
        },
      ],
    },

    {
      label: "Students",
      icon: <FaChalkboardTeacher />,
      innerComponents: [
        {
          label: t("Listings"),
          icon: <FaUsers />,
          url: "/dashboard/student/Lists",
          component: StudentsList,
        },
        {
          label: "Attendance",
          icon: <FaUsers />,
          url: "/dashboard/student/attendance",
          component: StudentAttendanceList,
        },
        {
          label: "Awards",
          icon: <FaAward />,
          url: "/dashboard/student/awards",
          component: ViewAward,
        },
        {
          label: "Review Approve",
          icon: <FaAward />,
          url: "/dashboard/student/review-approve",
          component: ReviewApprove,
        },
      ],
    },
    {
      label: "Requests",
      icon: <MdVideoLibrary />, // Video library icon
      innerComponents: [
        {
          label: "Instructor",
          icon: <MdVideoLibrary />, // Video library icon
          url: "/dashboard/request/instructor",
          component: InstructorRequests,
        },
        {
          label: "CorporateTraining",
          icon: <FaAward />, // Award icon for quizzes
          url: "/dashboard/request/corporatetraining",
          component: RequestCorporateTraining,
        },
        /*  {
           label: "Course",
           icon: <FaVideo />,
           url: "/dashboard/request/course",
           component: WebinarEvents,
         }, */
        {
          label: "grievance-redressal",
          icon: <AiOutlineAppstore />,
          url: "/dashboard/request/grievanceredressal",
          component: Requestgrievanceredressal,
        },
        {
          label: "Contact",
          icon: <FaVideo />,
          url: "/dashboard/request/contact",
          component: RequestContact,
        },
        // {
        //   label: "Recruit Requests",
        //   icon: <FaVideo />,
        //   url: "/dashboard/requestRecruit",
        //   component: RequestRecruit,
        // },
        {
          label: "Partner",
          icon: <FaVideo />,
          url: "/dashboard/request/partner",
          component: RequestPartner,
        },
        {
          label: "Languisity",
          icon: <BiBookBookmark />,
          url: "/dashboard/report/lang",
          component: LanguisityReport,
        },
        {
          label: "smik-recurit",
          icon: <FaVideo />,
          url: "/dashboard/Contactusrequests",
          component: Contactusrequests,
        },
        {
          label: "Contact-sales Requests",
          icon: <FaVideo />,
          url: "/dashboard/ContactSales",
          component: ContactSales,
        },
      ],
    },
    {
      label: "Sub Menu",
      icon: <AiOutlineAppstore />,
      innerComponents: [
        {
          label: "Home Banner",
          icon: <MdWeb />,
          url: "/dashboard/hero",
          component: HomePreview,
        },
        {
          label: "Home Achivements",
          icon: <FaAward />,
          url: "/dashboard/sub/preview",
          component: Preview,
        },
        {
          label: "Industry Project",
          icon: <AiOutlineProject />, // Project icon
          url: "/dashboard/sub/courseproject",
          component: CourseProject,
        },
        {
          label: "What Expert Say",
          icon: <FaPerson />,
          url: "/dashboard/sub/expertsSay",
          component: Testimonials,
        },
        {
          label: "Pricing Plans",
          icon: <FaPerson />,
          url: "/dashboard/Pricing",
          component: PricingPlans,
        },
        {
          label: "Jsons",
          icon: <FaPerson />,
          url: "/dashboard/jsons",
          component: JsonPageEditor,
        },
        {
          label: "SEO",
          icon: <FaPerson />,
          url: "/dashboard/seo",
          component: SeoPage,
        },
      ],
    },
    {
      label: t("Reports"),
      icon: <FaChartBar />,
      innerComponents: [
        {
          label: t("Student details"),
          icon: <FaUsers />,
          url: "/dashboard/student/list",
          component: StudentData,
        },
        {
          label: t("Course Details"),
          icon: <MdVideoLibrary />,
          url: "/dashboard/report/course",
          component: CourseReport,
        },
        {
          // <<<<<<< muthulat
          label: t("Monthwise Report"),
          icon: <FaChartBar />,
          url: "/dashboard/report/monthly",
          component: MonthReport,
          // =======
          //           label: "Course Requests",
          //           icon: <FaVideo />,
          //           url: "/dashboard/requestCourse",
          //           component: RequestCourse,
          // >>>>>>> developnew
        },
        {
          label: t("Instructor Details"),
          icon: <FaChalkboardTeacher />,
          url: "/dashboard/report/teacher",
          component: TeacherReport,
        },
        {
          label: t("Monthwise Payment"),
          icon: <FaChartBar />,
          url: "/dashboard/report/payment",
          component: PaymentReport,
        },
        {
          label: t("Quiz Results"),
          icon: <FaAward />,
          url: "/dashboard/report/quiz-results",
          component: AdminQuizResults,
        },
        {
          label: "Group Feedbacks",
          icon: <FaComments />,
          url: "/dashboard/report/group-feedbacks",
          component: GroupFeedbacksReport,
        },
      ],
    },

    {
      label: "Announcement",
      icon: <FaBullhorn />,
      url: "/dashboard/Announcement",
      component: Announcement,
    },
    // {
    //   label: "Jobs",
    //   icon: <FaBriefcase />,
    //   url: "/dashboard/jobs",
    //   component: JobsManagement,
    // },
    // {
    //   label: "Public Section",
    //   icon: <MdVideoLibrary />, // Video library icon
    //   innerComponents: [
    //     {
    //       label: "AboutUs",
    //       icon: <MdVideoLibrary />, // Video library icon
    //       url: "/dashboard/public/about-us",
    //       component: Aboutus,
    //     },
    //     {
    //       label: "About Info",
    //       icon: <MdVideoLibrary />, // Video library icon
    //       url: "/dashboard/public/about-info",
    //       component: AboutInfo,
    //     },
    //   ]
    // }
  ];


  const enterpriseMenu = [
    {
      label: t("Subscription"),
      icon: "icon icon-courses",
      url: "/dashboard",
      component: CurrentSubscription,
    },
  ];

  const studentMenu = [
    {
      label: t("sideMenu.dashboard"),
      icon: <FaHome />,
      url: "/dashboard",
      component: StudentDashboard,
    },
    {
      label: "Courses",
      icon: <FaBookOpen />,
      innerComponents: [
        {
          label: "My Courses",
          key: 1,
          icon: <FaBookOpen />,
          url: "/dashboard/course/list",
          component: CourseList,
        },
        {
          label: t("sideMenu.shopCourses"),
          key: 2,
          icon: <FaShoppingCart />,
          url: "/courses",
        },
        {
          label: t("sideMenu.myWishlist"),
          key: 3,
          icon: <FaHeart />,
          url: "/dashboard/wishlist",
          component: Wishlist,
        },
        {
          key: 4,
          label: t("My Webinars"),
          icon: <FaVideo />,
          url: "/dashboard/webinars/list",
          component: WebinarEvents,
        },
        {
          key: 5,
          label: "Live Classes",
          icon: <FaVideo />,
          url: "/dashboard/student/classes",
          component: StudentClasses,
        },
      ],
    },
    // {
    //   key: 5,
    //   label: t("sideMenu.results"),
    //   icon: <FaChartBar />,
    //   url: "/dashboard/results",
    //   component: StudentResult,
    // },
    {
      key: 5,
      label: "Group",
      icon: <FaUsers />,
      url: "/dashboard/student/group",
      component: StudentGroupBatchList,
    },
    {
      key: 6,
      label: t("sideMenu.notes"),
      icon: <FaStickyNote />,
      url: "/dashboard/student/notes",
      component: StudentNotes,
    },
    {
      key: 7,
      label: "Community",
      icon: <FaComments />,
      url: "/dashboard/student/forum",
      component: StudentForum,
    },
    {
      key: 8,
      label: t("sideMenu.achievements"),
      icon: <FaTrophy />,
      url: "/dashboard/student/achievements",
      component: StudentAchievements,
    },
    {
      key: 9,
      label: t("sideMenu.announcements"),
      icon: <FaBullhorn />,
      url: "/dashboard/announcements",
      component: StudentAnnouncement,
    },
    {
      key: 10,
      label: t("View Awards"),
      icon: <FaAward />,
      url: "/dashboard/student/awards",
      component: ViewAward,
    },
    {
      label: "Exams",
      icon: <FaBookOpen />,
      innerComponents: [
        {
          key: 11,
          label: t("Exams Result"),
          icon: <FaListAlt />,
          url: "/dashboard/student/results",
          component: QuizResult,
        },
        {
          key: 12,
          label: t("Exam"),
          icon: <FaBook />,
          url: "/dashboard/student/QuizExam",
          component: QuizExam,
        },
      ]
    },
    {
      key: 13,
      label: "My Attendance",
      icon: <FaCalendarAlt />,
      url: "/dashboard/student/my-attendance",
      component: StudentCourseAttendance,
    },
    // {
    //   key: 14,
    //   label: "Daily Attendance",
    //   icon: <FaCalendarAlt />,
    //   url: "/dashboard/student/daily-attendance",
    //   component: StudentAttendance,
    // },


  ];

  const teacherMenu = [
    {
      label: t("sideMenu.dashboard"),
      icon: <FaHome />,
      url: "/dashboard",
      component: StudentDashboard,
    },
    {
      label: "Course List",
      icon: <FaBookOpen />,
      url: "/dashboard/course/list",
      component: CourseList,
    },
    {
      label: "Manage Classes",
      icon: <FaCalendarAlt />,
      url: "/dashboard/instructor/classes",
      component: InstructorClasses,
    },
    {
      label: "Student List",
      icon: <FaUserGraduate />,
      url: "/dashboard/instructor/studentlist",
      component: InstructorStudentList,
    },
    {
      label: "Student Attendance",
      icon: <FaUserGraduate />,
      url: "/dashboard/verify/attendance",
      component: VerifyAttendance,
    },
    {
      label: t("View Awards"),
      icon: <FaAward />,
      url: "/dashboard/ViewAward",
      component: ViewAward,
    },
    {
      label: "Announcement",
      icon: <FaBullhorn />,
      url: "/dashboard/Announcement",
      component: Announcement,
    },
    {
      label: t("Quiz Result"),
      icon: <FaListAlt />,
      url: "/dashboard/student/results",
      component: QuizResult,
    },
    {
      label: t("sideMenu.webinars"),
      icon: <FaVideo />,
      url: "/dashboard/webinars/list",
      component: WebinarEvents,
    },
    {
      label: "Availability",
      icon: <FaCalendarAlt />,
      innerComponents: [
        {
          label: "Batch Schedules",
          icon: <FaListAlt />,
          url: "/dashboard/instructor/schedules",
          component: InstructorBatchSchedules,
        },
        {
          label: "Create Batch",
          icon: <FaPlus />,
          url: "/dashboard/instructor/create-batch",
          component: InstructorCreateBatch,
        },
      ],
    },
  ];


  // const instituteMenu = [
  //   {
  //     label: "Dashboard",
  //     icon: "icon icon-home",
  //     // component: "Institute Dashboard",
  //   },
  //   {
  //     label: "Teachers",
  //     icon: "T",
  //     // component: "Institute - Teachers",
  //   },
  //   {
  //     label: "Students",
  //     icon: "icon icon-students",
  //     // component: "Institute > Students",
  //   },

  //   {
  //     label: "Webinar(s)",
  //     icon: "icon icon-video",
  //     // component: "Institute > Webinars",
  //   },
  //   {
  //     label: "Categories",
  //     icon: "C",
  //     // component: "Institute > Categories",
  //   },
  //   {
  //     label: "Subjects",
  //     icon: "s",
  //     // component: "Institute > Subjects",
  //   },
  //   {
  //     label: "Forum",
  //     icon: "icon icon-forum",
  //     // component: "Institute > Forums",
  //   },
  // ];

  const parentsMenu = [
    {
      label: "Dashboard",
      icon: "icon icon-home",
      component: "parent > dashboard",
    },
    {
      label: "Students",
      icon: "icon icon-students",
      component: "parent > Students",
    },
    {
      label: "Reports",
      icon: "icon icon-reports",
      component: "parent > Reports",
    },
    {
      label: "Webinar(s)",
      icon: "icon icon-video",
      component: "parent > Webinars",
    },
    {
      label: "Announcements",
      icon: "icon icon-mic",
      component: "parent > Announcements",
    },
    {
      label: "Forums",
      icon: "icon icon-forum",
      component: "parent > forums",
    },
  ];

  //role 1 for admin
  //role 2 for student
  //role 3 for institute
  //role 4 for instructor
  //role 5 for parent
  // console.log("user", user);
  // switch (user.role) {
  //   case 1:
  //     var sideMenu = adminMenu;
  //     break;
  //   case 2:
  //     var sideMenu = studentMenu;
  //     break;
  //   case 3:
  //     var sideMenu = enterpriseMenu;
  //     break;
  //   case 4:
  //     var sideMenu = teacherMenu;
  //     break;
  //   default:
  //     var sideMenu = studentMenu;
  // }

  const roleMenu = () => {
    if (user.role == "1") {
      return adminMenu;
    } else if (user.role == "2") {
      return studentMenu;
    } else if (user.role == "3") {
      return enterpriseMenu;
    } else if (user.role == "4") {
      return teacherMenu;
    } else {
      return studentMenu;
    }
    return [];
  };
  const hideSidebars = () => {
    const pathsToHide = [
      "/dashboard/coursebuilder",
    ];
    if (location.search.includes("fullscreen=true")) {
      return true;
    }
    return pathsToHide.some(path =>
      location.pathname.toLowerCase().includes(path.toLowerCase())
    );
  };
  // console.log("sidemenu", sideMenu)
  return (
    <>
      <div className="App back-panel">
        {/* <div className="App back-panel"> */}
        <div className="container-dashboard">
          {/* Import Navbar here */}

          {!hideSidebars() && (
            <div className={showIconsOnly ? "left-panel1" : "left-panel"}>
              <div className="logo-wrapper">
                {showIconsOnly && (
                  <Link aria-label="Dashboard Home" to="/" className="sidebar-logo-icon">
                    <img src={smiklogo} alt="Yuvasakthi Academy" className="sidebar-logo-icon-img" />
                  </Link>
                )}
                <div
                  className="abc"
                  onClick={() => setShowIconsOnly(!showIconsOnly)}
                >
                  <svg viewBox="0 0 24 24" width="20" height="20" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" fill="none">
                    <line x1="4" y1="12" x2="20" y2="12"></line>
                    <line x1="4" y1="6" x2="20" y2="6"></line>
                    <line x1="4" y1="18" x2="20" y2="18"></line>
                  </svg>
                </div>
                {!showIconsOnly && (
                  <Link aria-label="Dashboard Home" to="/" className="sidebar-logo-link">
                    <img src={smiklogo} alt="Yuvasakthi Academy" className="menulogo-img" />
                    <span className="sidebar-logo-text">Yuvasakthi Academy</span>
                  </Link>
                )}
              </div>

              <ul
                key="left-panel"
                className={`dropdownMenu ${showIconsOnly ? "mt-0" : "mt-10"}`}
              >
                {roleMenu().map((item, key) => {
                  const hasActiveChild = item.innerComponents?.some(
                    (ele) => location.pathname === ele.url
                  );
                  return item.url ? (

                    <li
                      className={
                        location.pathname === item.url
                          ? "dropdownItem active"
                          : "dropdownItem"
                      }
                      key={item.url}
                    >
                      <Tippy
                        content={item.label}
                        placement="right"
                        disabled={!showIconsOnly}
                        arrow={true}
                        delay={[100, 0]}
                      >
                        <Link to={item?.url} onClick={() => setShowIconsOnly(true)} className={showIconsOnly ? "!px-2 sidebar-tooltip-wrap" : "!px-2"}>
                          {showIconsOnly ? (
                            <span className="!text-[20px]">{item.icon}</span>
                          ) : (
                            <>
                              <span className="!text-[20px]">{item.icon}</span>
                              <span className="!text-[17px] !ml-3 !font-semibold"><b>{item.label}</b></span>
                            </>
                          )}
                        </Link>
                      </Tippy>
                    </li>
                  ) : (
                    <>
                      <li
                        className={`dropdownItem ${hasActiveChild ? "active" : ""} ${dropdownToggle === item.label ? "reports-dropdown-1" : "reports-dropdown"}`}
                        onClick={() =>
                          setDropdownToggle(
                            dropdownToggle === item.label ? null : item.label
                          )
                        }
                        key={item.label}
                      >
                        <Tippy
                          content={item.label}
                          placement="right"
                          disabled={!showIconsOnly}
                          arrow={true}
                          delay={[100, 0]}
                        >
                          <a className={showIconsOnly ? "!px-2 sidebar-tooltip-wrap" : "!px-2"}>
                            {showIconsOnly ? (
                              <span className="!text-[20px]">{item.icon}</span>
                            ) : (
                              <>
                                <span className="!text-[20px]">{item.icon}</span>
                                <b><span className="!text-[17px] !ml-3 !font-semibold"><b>{item.label}</b></span>
                                  {/* <span></span> */}
                                </b>
                              </>
                            )}
                          </a>
                        </Tippy>
                      </li>
                      <div
                        className={`${(dropdownToggle === item.label || hasActiveChild) ? "height-auto" : "height-0"}`}
                      >
                        {item?.innerComponents?.map((ele, index) => (
                          <li
                            className={
                              location.pathname === ele.url
                                ? "dropdownItem active"
                                : "dropdownItem"
                            }
                            key={ele.url} // Use ele.url to ensure uniqueness for inner components
                          >
                            <Tippy
                              content={`${item.label} - ${ele.label}`}
                              placement="right"
                              disabled={!showIconsOnly}
                              arrow={true}
                              delay={[100, 0]}
                            >
                              <Link to={ele?.url} onClick={() => setShowIconsOnly(true)} className={showIconsOnly ? "!px-2 sidebar-tooltip-wrap" : "!px-2"}>
                                {showIconsOnly ? (
                                  <span className="!text-[16px]">{ele.icon}</span>
                                ) : (
                                  <div className="flex items-center">
                                    <span className="!text-[17px]">{ele.icon}</span>
                                    <span className="!text-[17px] !ml-3 !font-medium"><b>{ele.label}</b></span>
                                  </div>
                                )}
                              </Link>
                            </Tippy>
                          </li>
                        ))}
                      </div>
                    </>
                  );
                })}
              </ul>
              <div className="sidebar-bottom-color">
                <p>Copyright &copy; 2022 yslearn.in</p>
              </div>
            </div>
          )}

          <div
            key="right-panel"
            className={hideSidebars() ? "w-full min-h-screen" : (showIconsOnly ? "right-panel1" : "right-panel")}
          >
            {!hideSidebars() && <Navbar />}

            {/* <Router> */}
            <Routes>
              <Route path="/profile" element={<Profile />} />
              <Route path="/calendar" element={<CalendarPage />} />
              <Route path="/reminders" element={<RemindersPage />} />
              <Route path="/settings" element={<SettingsPage />} />
              <Route path="/coursebuilder/:id?" element={<CourseBuilder />} />
              <Route path="/course/edit/:id" element={<CourseEdit />} />
              <Route path="/course/create/:id" element={<CreateCourse />} />
              <Route
                path="/course/add-section"
                element={<CreateCourseSection />}
              />
              <Route path="/student/awards" element={<ViewAward />} />
              <Route path="/ViewAward" element={<ViewAward />} />
              <Route path="/student/results" element={<QuizResult />} />
              <Route path="/student/quizs" element={<Quizs />} />
              <Route path="/student/quizexam" element={<QuizExam />} />
              <Route path="/student/classes" element={<StudentClasses />} />
              <Route path="/instructor/classes" element={<InstructorClasses />} />
              <Route path="/admin/classes" element={<InstructorClasses />} />
              <Route
                path="/CurrentSubscription"
                element={<CurrentSubscription />}
              />
              <Route path="/" element={<StudentDashboard />} />
              <Route path="/course/list" element={<CourseList />} />
              <Route path="/webinars/list" element={<WebinarEvents />} />
              <Route path="/course/CreateBundle" element={<CreateBundle />} />
              <Route path="/student/list" element={<StudentData />} />
              <Route path="/report/course" element={<CourseReport />} />
              <Route path="/report/monthly" element={<MonthReport />} />
              <Route path="/report/teacher" element={<TeacherReport />} />
              <Route path="/report/payment" element={<PaymentReport />} />
              <Route path="/report/quiz-results" element={<AdminQuizResults />} />
              <Route path="/report/group-feedbacks" element={<GroupFeedbacksReport />} />
              <Route path="/report/lang" element={<LanguisityReport />} />
              <Route path="/bundle/list" element={<BundleList />} />
              <Route path="/wishlist" element={<Wishlist />} />
              {/* <Route path="/results" element={<StudentResult />} /> */}
              <Route path="/student/notes" element={<StudentNotes />} />
              <Route path="/student/forum" element={<StudentForum />} />
              <Route path="/student/achievements" element={<StudentAchievements />} />
              <Route path="/student/my-attendance" element={<StudentCourseAttendance />} />
              {/* <Route path="/student/daily-attendance" element={<StudentAttendance />} /> */}
              <Route path="/announcements" element={<StudentAnnouncement />} />
              <Route path="/instructor/List" element={<MemberList />} />
              <Route path="/student/Lists" element={<StudentsList />} />
              <Route path="/course/list" element={<CourseList />} />
              <Route path="/instructor/studentlist" element={<InstructorStudentList />} />
              <Route path="/Announcement" element={<Announcement />} />
              <Route path="/category/list" element={<AllCategories />} />
              <Route path="/admin/offers" element={<CreateOfferPage />} />
              <Route path="/admin/coupons" element={<CreateCouponPage />} />
              <Route path="/pages" element={<PageData />} />
              <Route path="/sub/courseProject" element={<CourseProject />} />
              <Route path="/hero" element={<HomePreview />} />
              <Route path="/sub/preview" element={<Preview />} />
              <Route path="/sub/expertsSay" element={<Testimonials />} />
              <Route path="/course/purchasedlist" element={<CoursePurchasedList />} />
              <Route path="/instructor/attendance" element={<InstructorAttendance />} />
              <Route path="/student/attendance" element={<StudentAttendanceList />} />
              <Route path="/student/review-approve" element={<ReviewApprove />} />
              <Route path="/verify/attendance" element={<VerifyAttendance />} />
              <Route path="/verifyAttendance" element={<VerifyAttendance />} />
              <Route path="/group" element={<BatchGroup />} />

              <Route path="/student/group" element={<StudentGroupBatchList />} />
              <Route path="/instructor/schedules" element={<InstructorBatchSchedules />} />
              <Route path="/instructor/create-batch" element={<InstructorCreateBatch />} />
              <Route path="/request/instructor" element={<InstructorRequests />} />
              <Route path="/request/corporatetraining" element={<RequestCorporateTraining />} />
              <Route path="/request/grievanceredressal" element={<Requestgrievanceredressal />} />
              <Route path="/request/contact" element={<RequestContact />} />
              <Route path="/request/partner" element={<RequestPartner />} />

              <Route path="/requestCourse" element={<RequestCourse />} />
              <Route path="/Contactusrequests" element={<Contactusrequests />} />
              <Route path="/Pricing" element={<PricingPlans />} />
              <Route path="/ContactSales" element={<ContactSales />} />
              <Route path="/public/about-us" element={<Aboutus />} />
              <Route path="/public/about-info" element={<AboutInfo />} />
              <Route path="/jsons" element={<JsonPageEditor />} />
              <Route path="/seo" element={<SeoPage />} />
              {/* prompting */}
              <Route path="/prompt/quiz" element={<ExamAndQuiz />} />
              <Route path="/prompt/webinar" element={<Webinar />} />


              {/* Dynamic routes based on role menu */}
              {roleMenu().map((item) => {
                if (!item.url || !item.component) return null;
                const Comp = item.component;
                return <Route path={item.url} element={<Comp />} key={item.url} />;
              })}
              {roleMenu().map((item) =>
                item.innerComponents
                  ? item.innerComponents.map((innerItem) => {
                    if (!innerItem.url || !innerItem.component) return null;
                    const Comp = innerItem.component;
                    return <Route path={innerItem.url} element={<Comp />} key={innerItem.url} />;
                  })
                  : null
              )}
              <Route path="*" element={<Error404 />} />
              {/* <Route path="*" element={<Error404 />} /> */}
            </Routes>
            {/* </Router> */}
          </div>
        </div>
      </div>
      {/* <SessionExpire /> */}
    </>
  );
}
